import { idGenerator } from '@/services'

export interface NewConnectionCmhState {
  requestId: string
  totalPrice: number | null
}

export const InitialState: NewConnectionCmhState = {
  requestId: idGenerator.getNewWebReference(),
  totalPrice: null
}

